// Polyfills for browser compatibility
import { Buffer } from 'buffer';

// Make Buffer available globally
(window as any).Buffer = Buffer;
(globalThis as any).Buffer = Buffer;

// Also ensure global is defined
if (typeof (window as any).global === 'undefined') {
  (window as any).global = window;
}
